import * as Styles from './StatusChip.styles';

export type StatusConfig = {
  /** Human-readable label shown on the chip. */
  label: string;
  /** Color for the chip (hex, rgb, or named). */
  color: string;
  /** Chip variant. Defaults to 'filled'. */
  variant?: 'filled' | 'outlined';
};

export type StatusChipProps = {
  /** The current status key (must exist in statusMap). */
  status: string;
  /** A mapping from status keys to their display configuration. */
  statusMap: Record<string, StatusConfig>;
  /** Chip size. Defaults to 'small'. */
  size?: 'small' | 'medium';
};

const StatusChip = function ({
  status,
  statusMap,
  size = 'small',
}: StatusChipProps): JSX.Element {
  const config = statusMap[status];

  if (!config) {
    return <Styles.FallbackChip $size={size}>{status}</Styles.FallbackChip>;
  }

  return (
    <Styles.Chip
      $color={config.color}
      $variant={config.variant ?? 'filled'}
      $size={size}
    >
      {config.label}
    </Styles.Chip>
  );
};

export default StatusChip;
